export default __webpack_public_path__ + "static/media/skysense_v2.97450c14.png";